module.exports = __webpack_public_path__ + "img/734.a47c854b.png";